import React from 'react';

export default function TermsConditionsPage() {
  return (
    <div className="cs_terms_page">
      <div className="container">
        <div className="cs_terms_container">
          <h1>Terms and Conditions</h1>
          <p className="cs_last_updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
          </section>

          <section>
            <h2>2. Product Information</h2>
            <p>Ayumedix Wellness Capsule is a wellness supplement designed to support Men’s Wellness, energy levels, and overall endurance.</p>
            <ul>
              <li>This product is not intended to diagnose, treat, cure, or prevent any disease</li>
              <li>Consult your healthcare provider before use if you have medical conditions</li>
              <li>Keep out of reach of children</li>
            </ul>
          </section>


          <section>
            <h2>3. Orders and Payment</h2>
            <h3>Order Processing</h3>
            <ul>
              <li>All orders are subject to availability and confirmation</li>
              <li>We reserve the right to refuse or cancel orders at our discretion</li>
              <li>Order confirmation will be sent via email</li>
              <li>Only prepaid orders are accepted</li>
            </ul>
            
            <h3>Payment Terms</h3>
            <ul>
              <li>All payments are processed securely through Razorpay</li>
              <li>We accept credit cards, debit cards, UPI, net banking, and digital wallets</li>
              <li>Payment must be completed at the time of order placement</li>
              <li>No cash on delivery (COD) option available</li>
            </ul>
          </section>

          <section>
            <h2>4. Pricing and Availability</h2>
            <ul>
              <li>All prices are listed in Indian Rupees (INR) and include applicable taxes</li>
              <li>Prices are subject to change without prior notice</li>
              <li>Product availability is subject to stock levels</li>
              <li>We reserve the right to limit quantities purchased</li>
            </ul>
          </section>

          <section>
            <h2>5. Shipping and Delivery</h2>
            <ul>
              <li>We ship within India only</li>
              <li>Delivery timeframes are estimates and not guaranteed</li>
              <li>Shipping charges may apply based on location and order value</li>
              <li>Risk of loss passes to you upon delivery</li>
              <li>Secure packaging is provided to ensure product safety</li>
            </ul>
          </section>

          <section>
            <h2>6. Returns and Refunds</h2>
            <ul>
              <li>Returns are accepted within 7 days of delivery for unopened products</li>
              <li>Products must be in original packaging and unused condition</li>
              <li>Refunds will be processed within 7-10 business days</li>
              <li>Return shipping costs are borne by the customer unless the product is defective</li>
              <li>Opened or used products cannot be returned for hygiene reasons</li>
            </ul>
          </section>

          <section>
            <h2>7. Privacy and Confidentiality</h2>
            <p>We respect your privacy and maintain strict confidentiality of your personal information. All orders are processed securely, and your information is protected as per our Privacy Policy.</p>
          </section>

          <section>
            <h2>8. Disclaimers</h2>
            <ul>
              <li>Results and benefits may vary depending on individual lifestyle and diet</li>
              <li>This product is a dietary supplement and not intended to diagnose, treat, cure, or prevent any disease</li>
              <li>We strive to deliver high-quality, authentic formulations, though individual wellness outcomes may vary</li>
              <li>Please consult with your healthcare provider if you have any medical conditions</li>
            </ul>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>Our goal is to ensure your complete satisfaction. Our liability is limited to the extent permitted by law, generally addressing the purchase price of the product. We aim to support your wellness journey responsibly.</p>
          </section>

          <section>
            <h2>10. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, and images, is our property and protected by copyright laws. Unauthorized use is prohibited.</p>
          </section>

          <section>
            <h2>11. Governing Law</h2>
            <p>These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of Indian courts.</p>
          </section>

          <section>
            <h2>12. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on this website.</p>
          </section>

          <section>
            <h2>13. Contact Information</h2>
            <p>For questions about these terms, contact us at:</p>
            <p>Email: support@ayumedix.com<br/>
            WhatsApp: <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a></p>
          </section>
        </div>
      </div>

      <style jsx>{`
        .cs_terms_page {
          min-height: 100vh;
          background: #f8f8f8;
          padding: 120px 0 80px;
        }
        .cs_terms_container {
          max-width: 800px;
          margin: 0 auto;
          background: #ffffff;
          padding: 50px;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(18, 18, 18, 0.08);
        }
        .cs_terms_container h1 {
          color: #121212;
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 10px;
          text-align: center;
        }
        .cs_last_updated {
          text-align: center;
          color: #666;
          margin-bottom: 40px;
          font-style: italic;
        }
        .cs_terms_container section {
          margin-bottom: 35px;
        }
        .cs_terms_container h2 {
          color: #121212;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 15px;
          border-bottom: 2px solid #0b5e4b;
          padding-bottom: 5px;
        }
        .cs_terms_container h3 {
          color: #121212;
          font-size: 18px;
          font-weight: 600;
          margin: 20px 0 10px;
        }
        .cs_terms_container p {
          color: #4f4747;
          line-height: 1.6;
          margin-bottom: 15px;
        }
        .cs_terms_container ul {
          color: #4f4747;
          line-height: 1.6;
          margin-left: 20px;
        }
        .cs_terms_container li {
          margin-bottom: 8px;
        }
        @media (max-width: 768px) {
          .cs_terms_page {
            padding: 100px 0 50px;
          }
          .cs_terms_container {
            margin: 0 20px;
            padding: 30px 25px;
          }
          .cs_terms_container h1 {
            font-size: 28px;
          }
          .cs_terms_container h2 {
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
}